<template>
  <AppBody :subtitle="getSubTitle">
    <template>
      <v-stepper v-model="stepProgram" vertical>
        <v-stepper-step
          :color="$config.dados.corinputs"
          :complete="stepProgram > 1"
          step="1"
        >
          {{ $t('sales.affiliates_program_name') }}
        </v-stepper-step>

        <v-stepper-content step="1">
          <v-row>
            <v-col :cols="!mdAndUp ? 12 : 3">
              <v-card elevation="0">
                <v-card-title>
                  <v-icon class="mr-2">mdi-text</v-icon>
                  {{ $t('sales.affiliates_program_basic_information') }}
                </v-card-title>
                <v-card-subtitle class="ml-1">
                  {{ $t('sales.affiliates_program_url_information') }}
                </v-card-subtitle>
              </v-card>
            </v-col>
            <v-col :cols="!mdAndUp ? 12 : 9">
              <NameComponent />
            </v-col>
          </v-row>
        </v-stepper-content>

        <v-stepper-step
          :color="$config.dados.corinputs"
          :complete="stepProgram > 2"
          step="2"
        >
          {{ $t('sales.affiliates_program_commissioning') }}
        </v-stepper-step>
        <v-stepper-content step="2">
          <v-row>
            <v-col :cols="!mdAndUp ? 12 : 3">
              <v-card elevation="0">
                <v-card-title>
                  <v-icon class="mr-2">mdi-text</v-icon>
                  {{$t('sales.affiliates_program_commissioning') }}
                </v-card-title>
                <v-card-subtitle class="ml-1">
                  {{ $t('sales.affiliates_program_commissioning_info') }}
                </v-card-subtitle>
              </v-card>
            </v-col>
            <v-col :cols="!mdAndUp ? 12 : 9">
              <Commissioning />
            </v-col>
          </v-row>
        </v-stepper-content>

        <v-stepper-step
          :color="$config.dados.corinputs"
          :complete="stepProgram > 3"
          step="3"
        >
          {{ $t('sales.affiliates_program_limits') }}
        </v-stepper-step>

        <v-stepper-content step="3">
          <v-row>
            <v-col :cols="!mdAndUp ? 12 : 3">
              <v-card elevation="0">
                <v-card-title>
                  <v-icon class="mr-2">mdi-text</v-icon>
                  {{ $t('sales.affiliates_program_limits_restrictions') }}
                </v-card-title>
                <v-card-subtitle class="ml-1">
                  {{ $t('sales.affiliates_program_limits_restrictions_info') }}
                </v-card-subtitle>
              </v-card>
            </v-col>
            <v-col :cols="!mdAndUp ? 12 : 9">
              <Limits />
            </v-col>
          </v-row>
        </v-stepper-content>

        <v-stepper-step
          :complete="stepProgram > 4"
          :color="$config.dados.corinputs"
          step="4"
        >
          {{ $t('sales.affiliates_program_affiliates') }}
        </v-stepper-step>
        <v-stepper-content step="4">
          <v-row>
            <v-col :cols="!mdAndUp ? 12 : 3">
              <v-card elevation="0">
                <v-card-title>
                  <v-icon class="mr-2">mdi-text</v-icon>
                  {{  $t('sales.affiliates_program_affiliates_select')  }}
                </v-card-title>
                <v-card-subtitle class="ml-1">
                  {{  $t('sales.affiliates_program_affiliates_select_all')  }}
                </v-card-subtitle>
              </v-card>
            </v-col>
            <v-col :cols="!mdAndUp ? 12 : 9">
              <Affiliates />
            </v-col>
          </v-row>
        </v-stepper-content>

        <v-stepper-step
          :complete="stepProgram > 5"
          :color="$config.dados.corinputs"
          step="5"
        >
          {{ $t('sales.affiliates_program_discount') }}
        </v-stepper-step>
        <v-stepper-content step="5">
          <v-row>
            <v-col :cols="!mdAndUp ? 12 : 3">
              <v-card elevation="0">
                <v-card-title>
                  <v-icon class="mr-2">mdi-text</v-icon>
                  {{ $t('sales.affiliates_program_discount_config') }}
                </v-card-title>
                <v-card-subtitle class="ml-1">
                  {{ $t('sales.affiliates_program_discount_info') }}
                </v-card-subtitle>
              </v-card>
            </v-col>
            <v-col :cols="!mdAndUp ? 12 : 9">
              <Discount />
            </v-col>
          </v-row>
        </v-stepper-content>

        <v-stepper-step
          :complete="stepProgram > 6"
          :color="$config.dados.corinputs"
          step="6"
        >
          {{ $t('sales.affiliates_program_publish') }}
        </v-stepper-step>
        <v-stepper-content step="6">
          <v-row>
            <v-col :cols="!mdAndUp ? 12 : 3">
              <v-card elevation="0">
                <v-card-title>
                  <v-icon class="mr-2">mdi-text</v-icon>
                  {{ $t('sales.affiliates_program_publish_summary') }}
                </v-card-title>
                <v-card-subtitle class="ml-1">
                  {{ $t('sales.affiliates_program_publish_summary_info') }}
                </v-card-subtitle>
              </v-card>
            </v-col>
            <v-col :cols="!mdAndUp ? 12 : 9">
              <Publish />
            </v-col>
          </v-row>
        </v-stepper-content>
      </v-stepper>
    </template>
  </AppBody>
</template>

<script>
import AppBody from "@/layouts/components/AppBody.vue";
import NameComponent from "@/components/vendas/AffiliatesProgram/Name.vue";
import Commissioning from "@/components/vendas/AffiliatesProgram/Commissioning.vue";
import Limits from "@/components/vendas/AffiliatesProgram/Limits.vue";
import Affiliates from "@/components/vendas/AffiliatesProgram/Affiliates.vue";
import Discount from "@/components/vendas/AffiliatesProgram/Discount.vue";
import Publish from "@/components/vendas/AffiliatesProgram/Publish.vue";
import displayHelpers from "@/mixins/breakpoints.mixins";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "AffiliatesProgramSettings",
  mixins: [displayHelpers],
  components: {
    AppBody,
    NameComponent,
    Commissioning,
    Limits,
    Affiliates,
    Discount,
    Publish,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["stepProgram"]),
    getSubTitle() {
      return this.$t('sales.affiliates_program') + ` - ${this.$t('sales.' + this.$route.params.type.charAt(0).toUpperCase() +
      this.$route.params.type.slice(1))
      }`;
    },
  },
  methods: {
    ...mapActions(["stepBackProgram"]),
  },
  mounted() {},
};
</script>

<style scoped></style>
